module.exports = __webpack_public_path__ + "img/tierra.9ed713ed.png";